import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import type { PurchaseOrder, RouteDefAltPathHandler } from '@ztechapps/common.contract'

import { LocalDateTime } from '@ztechapps/webui.date'
import { ActivityListField } from '@ztechapps/webui.data-tools'
import { formatMoney } from '@ztechapps/common.utils'
import React from 'react'
import { usePurchaseOrderListContext } from './Context'
import { PurchaseOrderStatusBadge } from '../PurchaseOrderStatus/PurchaseOrderStatusBadge'
import { PurchaseOrderPaymentStatusBadge } from '../PurchaseOrderPaymentStatusBadge'
import { Link } from 'react-router-dom'

export const DataListRow = (props: BodyRowConfig<PurchaseOrder>) => {
  const { purchaseItemRoute, companyItemRoute, vendorItemRoute } = usePurchaseOrderListContext()

  const renderConfig = PurchaseOrderRenderDataBodyCellConfig({
    ...props,
    purchaseItemRouteDefAltPathHandler: purchaseItemRoute.altPath,
    companyItemRouteDefAltPathHandler: companyItemRoute.altPath,
    vendorItemRouteDefAltPathHandler: vendorItemRoute.altPath,
  })

  return props._renderDataBodyCell(renderConfig)
}

export const PurchaseOrderRenderDataBodyCellConfig = (
  props: {
    purchaseItemRouteDefAltPathHandler?: RouteDefAltPathHandler
    companyItemRouteDefAltPathHandler?: RouteDefAltPathHandler
    vendorItemRouteDefAltPathHandler?: RouteDefAltPathHandler
  } & BodyRowConfig<PurchaseOrder>
) => {
  const {
    _id,
    code,
    status,
    purchaseDate,
    net,
    vendor,
    estimatedArrivalDate,
    paymentStatus,
    remarks,
    remarksActivity,
    purchaseItemRouteDefAltPathHandler,
    companyItemRouteDefAltPathHandler,
    vendorItemRouteDefAltPathHandler,
  } = props

  return {
    code: (
      <Link to={purchaseItemRouteDefAltPathHandler?.({ _id })}>
        <b>{code}</b>
      </Link>
    ),
    purchaseDate: <LocalDateTime value={purchaseDate} />,
    estimatedArrivalDate: <LocalDateTime value={estimatedArrivalDate} />,
    status: <PurchaseOrderStatusBadge status={status} />,
    remarks: <ActivityListField remarks={remarks} remarksActivity={remarksActivity} />,
    contactName: (
      <Link to={vendorItemRouteDefAltPathHandler?.({ _id: vendor?._id })}>{vendor?.profile?.name ?? ''}</Link>
    ),
    vendor: (
      <Link to={companyItemRouteDefAltPathHandler?.({ _id: vendor?.company?._id })}>{vendor?.company?.name ?? ''}</Link>
    ),
    netAmount: <div className="fw-bold text-end">{formatMoney(net)}</div>,
    paymentStatus: paymentStatus && <PurchaseOrderPaymentStatusBadge paymentStatus={paymentStatus} />,
  }
}
